import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_IGCARTS_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Request interceptor to add authorization header
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor to handle errors, including 401
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      //   const navigate = useNavigate();
      //   navigate("/auth/login"); // Redirect to login on 401
    }
    return Promise.reject(error);
  }
);

export default api;
